import * as React from 'react';
import { PageSection, Title } from '@patternfly/react-core';

const ProfileSettings: React.FunctionComponent = () => (
  <PageSection>
    <Title headingLevel="h1" size="lg">
      Profile Settings Page Title
    </Title>
  </PageSection>
);

export { ProfileSettings };
